var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cr_wrap"},[_c('div',{staticClass:"cr_body"},[_c('div',{staticClass:"cr_content"},[_c('img',{staticClass:"cr_img",attrs:{"src":_vm.IMG_LOGO_SUPPORT}}),_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cr_text_wrap"},[_c('div',{staticClass:"cr_text"},[_vm._v("技术支持")])])
}]

export { render, staticRenderFns }